/**
 * What an annotated CRF button tells the user when building it fails.
 *
 * A refusal (failed-precondition) carries the server's own reason: approve a
 * form, generate the SDTM mapping first. Show it rather than a fixed sentence;
 * the SDTM mapping panel used to replace every refusal with "Build and complete
 * your CRFs", which was wrong for both reasons (2026-10-14).
 */
export function acrfErrorMessage(err: { code?: string; message?: string } | null | undefined): string {
  const text = (err?.message ?? '')
    .replace(/^.*HttpsError[^:]*:\s*/i, '')
    .replace(/^FirebaseError:\s*/i, '')
    .replace(/^HTTPS callables.*?:\s*/i, '')
    .trim();
  if (text) return text;
  if (err?.code === 'functions/failed-precondition') {
    return 'Approve your case report forms and generate the SDTM mapping before building the annotated CRF.';
  }
  return 'The annotated CRF could not be built. Please try again.';
}
